import React from "react";

export default function Calendar() {
  return (
    <div style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
      <div className="bm-embedCalendar">
        <iframe
          title="Class Calendar"
          src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&src=YmVua29mc3RhZmZAZ21haWwuY29t&color=%23039BE5&showNav=0&showDate=1&showPrint=0&showTabs=0&showCalendars=0&mode=AGENDA"
          loading="lazy"
        />
      </div>
    </div>
  );
}
